import React, {  useState, useEffect } from 'react';
import { AdminPermissionAPI } from '../../../api/admin_permission';
import { TableAdminPermission } from '../../../components/Admin/AdminPermission';
import { useAuth } from '../../../hooks';

import { useParams } from "react-router";

const adminPermissionController = new AdminPermissionAPI();

export function AdminPermission() {
  let { statusRequest } = useParams();
  console.log("statusRequest")
  
  const [adminPermissions, setAdminPermissions] = useState(null);
  const [reload, setReload] = useState(false);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        console.log(statusRequest)
        const response = await adminPermissionController.getPermissions(accessToken, statusRequest);
        setAdminPermissions(response);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [reload,accessToken,statusRequest])

  // message when the table not have results.
  //if (size(adminPermissions) === 0) return <p>not results</p>;

  // reload form, table
  const onReload = () => setReload((prevState) => !prevState);
  

  return (
    <>
      <TableAdminPermission 
        adminPermissions={adminPermissions}
        onReload={onReload}
      />
    </>
  )
}
